// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.defect-scroll {
    max-width: 300px;
    max-height: 10.2em;
    overflow-y: auto;
    white-space: normal;
    scrollbar-width: auto;

}

/* Chrome / Safari / Edge */
.defect-scroll::-webkit-scrollbar {
    width: 5px;
}

.defect-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.defect-scroll::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 5px;
}

.defect-scroll::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}`, "",{"version":3,"sources":["webpack://./src/services/dvir/styles.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;;AAEzB;;AAEA,2BAA2B;AAC3B;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".defect-scroll {\n    max-width: 300px;\n    max-height: 10.2em;\n    overflow-y: auto;\n    white-space: normal;\n    scrollbar-width: auto;\n\n}\n\n/* Chrome / Safari / Edge */\n.defect-scroll::-webkit-scrollbar {\n    width: 5px;\n}\n\n.defect-scroll::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n\n.defect-scroll::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 5px;\n}\n\n.defect-scroll::-webkit-scrollbar-thumb:hover {\n    background: #a8a8a8;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
